import { useIntl } from "react-intl";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Table } from "react-lib/frameworks/Table";
import { Tab, Modal, Button, Icon, Popup } from "semantic-ui-react";
import TreatmentItem from "./TreatmentItem";
import ClinicalFindingsMenu from "./diagram/ClinicalFindingsMenu";
import GuideLine from "./GuideLine";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";

import ClinicalFindingsUX from "./ClinicalFindingsUX";
import ModalSetKeyboardShortcuts from "react-lib/apps/common/ModalSetKeyboardShortcuts";
import ModalEditImage from "react-lib/apps/common/ModalEditImage";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import Diagnosis from "./Diagnosis";
import "./DenTable.scss"
import SnackMessage from "react-lib/apps/common/SnackMessage";

const activeTissuetab = {
  0: "tooth",
  1: "face",
  2: "muscle",
  3: "null",
  4: "soft",
  5: "jaw",
};

const TEMPLATE_EXAMINATION: string = "EX";
export const CARDNAME = "DIAGNOSIS_TODAY";

const DiagnosisToday = (props: any) => {
  const intl = useIntl();
  const [errorTreatment, setErrorTreatment] = useState<any>([]);
  const [errorDivsion, setErrorDivsion] = useState<any>([]);
  const [errorDoctor, setErrorDoctor] = useState<any>([]);
  const [openModalError, setOpenModError] = useState(false);

  useEffect(() => {
    props.onEvent({
      message: "GetTreatmentSearchList",
      params: { no_parent: "true", limit: 100, offset: 0 },
    });
  }, []);

  const isTreatmentReadOnly = useMemo(() => {
    // 69940 ยังบันทึกได้บางส่วน

    // WAIT_TRIAGE = 1, 'รอคัดกรอง'
    // ARRIVING = 2, 'กําลังมาถึง'
    // ARRIVED = 3, 'มาถึง ณ หน่วยตรวจ'
    // SCREENED = 4, 'ซักประวัติแล้ว'
    // IN_QUEUE = 5, 'รอพบแพทย์'
    // IN_EXAM = 6, 'กำลังพบแพทย์'
    // WAIT_RESULT = 15, 'รอผลตรวจ'
    // RECEIVE_RESULT = 16, 'ได้รับผลตรวจ'
    // CHECKED_OUT = 10, 'ออกจากห้องตรวจ'
    // WAIT_PAY = 11, 'รอชำระเงินห้องการเงิน'
    // WAIT_DISPENSE = 12, 'รอรับบริการ'
    // DISCHARGED = 13, 'จำหน่ายผู้ป่วยกลับบ้าน'

    // กด "Checkout" (ปุ่มเขียว) หรือ Approve → den_approve_status = APPROVED; "Checkout Draft" → DRAFT (ยังแก้ได้)
    const lockedAfterApproval = props.encounterInfo?.den_approve_status === "APPROVED";
    return lockedAfterApproval || props.studentLocked;
  }, [props.encounterInfo, props.studentLocked]);

  const isExamDisabled =
    props.encounterInfo?.den_approve_status === "APPROVED" || props.studentLocked;



  //props.openClinicalFindingsMenu
  //
  // <Icon name="plus" color="green" style={{ marginRight: "10px" }}/>
  //
  // console.log("DiagnosisToday props:", props)
  // console.log(props)

  const handleCheckTreatmentItem = () => {
    var checkDivision: any[] = [];
    var checkDoctor: any[] = [];
    var errorTreatment: any[] = [];

    props.filteredTreatmentPlanList?.forEach((item: any, number: any) => {
      if (item.treatment === null) {
        errorTreatment.push(true);
      } else {
        errorTreatment.push(false);
      }

      if (item.division_label === undefined && item.division === null) {
        checkDivision.push(false);
      } else if (item.division_label !== "" && item.division === null) {
        checkDivision.push(true);
      } else {
        checkDivision.push(false);
      }

      if (item.doctor_full_name === undefined && item.doctor === null) {
        checkDoctor.push(false);
      } else if (item.doctor_full_name !== "" && item.doctor === null) {
        checkDoctor.push(true);
      } else {
        checkDoctor.push(false);
      }
    });

    setErrorTreatment(errorTreatment);
    setErrorDivsion(checkDivision);
    setErrorDoctor(checkDoctor);

    var checkErrorTreatment = false;
    var checkErrorDivision = false;
    var checkErrorDoctor = false;

    errorTreatment?.forEach((item: any) => {
      if (item === true) {
        checkErrorTreatment = true;
        return;
      }
    });

    checkDivision?.forEach((item: any) => {
      if (item === true) {
        checkErrorDivision = true;
        return;
      }
    });

    checkDoctor?.forEach((item: any) => {
      if (item === true) {
        checkErrorDoctor = true;
        return;
      }
    });

    if (checkErrorDivision || checkErrorDoctor || checkErrorTreatment) {
      setOpenModError(true);
      return;
    }

    handleSaveTreatmentItem();
  };

  useEffect(() => {
    setErrorTreatment([]);
    setErrorDivsion([]);
    setErrorDoctor([]);
  }, [props.showClinicalFindingsDetail]);

  const handleSaveTreatmentItem = async () => {
    // console.log('handleSaveTreatmentItem: call SaveClinicalFindingById  props.clinicalFinding: ', props.clinicalFinding);
    // console.log('handleSaveTreatmentItem: call SaveClinicalFindingById props.clinicalFinding.id: ', props.clinicalFinding?.id);

    await props.onEvent({
      message: "SaveClinicalFindingById",
      params: { id: props.clinicalFinding.id, saveTreatment: true, card: CARDNAME, btnAction: `${CARDNAME}_TP_SAVE` },
    });
    // props.setProp("showClinicalFindingsDetail", false);
    // props.setProp("clinicalFindingIndex", null);
  };

  // #useEffect(() => {
  //   if (props.successMessage?.[CARDNAME] === "success") {
  //     let success = props.successMessage
  //     delete success[CARDNAME]
  //     props.setProp("successMessage", success)
  //     props.setProp("showClinicalFindingsDetail", false);
  //     props.setProp("clinicalFindingIndex", null);
  //   }
  // }, [props.successMessage?.[CARDNAME]])

  return (
    <Tab
      menu={{ color: "green", secondary: true, pointing: true }}
      panes={[
        {
          menuItem: "Medical & Dental history",
          render: () => (
            <Tab.Pane style={{ backgroundColor: "#f5f5f5", marginTop: "-10px", border: "none" }}>
              <Diagnosis
                handleOnFocusClinialFindingsRow={props.handleOnFocusClinialFindingsRow}
                onEvent={props.onEvent}
                chiefcomplaints={props.chiefcomplaints}
                presentillness={props.presentillness}
                clinicalfindings={props.clinicalfindings}
                others={props.others}
                diagnosis={props.diagnosis}
                prognosis={props.prognosis}
                setProp={props.setProp}
                masterData={props.masterData}
                filterClinicalFindingIds={props.filterClinicalFindingIds}
                medicalHistoryList={props.medicalHistoryList}
                // filterClincialFindingId={}
                // filteredItem={props.filteredItem}
                summaryPreview={props.summaryPreview}
                encounter={props.encounter}
                encounterInfo={props.encounterInfo}
                encounterIndex={props.encounterIndex}
                keyboardShortcut={props.keyboardShortcut}
                studentLocked={props.studentLocked}
              />
            </Tab.Pane>
          ),
        },
        {
          menuItem: "Examination",
          render: () => (
            <Tab.Pane style={{ backgroundColor: "#f5f5f5", marginTop: "-10px", border: "none", padding: "6px" }}>
              <div className="box-clinical-findings-menu" style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ padding: "0px 0px 12px 0px", display: "flex" }}>
                  <GuideLine
                    selectorMode={props.selectorMode}
                    filterItem={props.filterItem}
                    openClinicalFindingsMenu={props.openClinicalFindingsMenu}
                    controller={props.controller}
                  />
                  {props.openClinicalFindingsMenu ? (
                    <ClinicalFindingsMenu
                      activeIndexDiagram={props.activeIndexDiagram}
                      onEvent={props.onEvent}
                      controller={props.controller}
                      clinicalFinding={props.clinicalFinding}
                    />
                  ) : null}
                </div>
                <div style={{ padding: "0px 0px 12px 0px" }}>
                  <Button
                    circular
                    color="blue"
                    icon="plus"
                    disabled={isExamDisabled}
                    onClick={(e) => {
                      props.onEvent({ message: "AddClinicalFinding", params: {} });
                    }}
                  />
                  <Button
                    circular
                    color="teal"
                    disabled={isExamDisabled}
                    onClick={async (e) => {
                      props.onEvent({ message: "GetReExaminationEncounter", params: { sub: "examination" } });
                    }}
                  >
                    {intl.formatMessage({ id: "cukey177" })}
                  </Button>
                </div>
              </div>
              <div className={`table-diagnosis active-${props.activeIndexDiagram}`}>
                <Table
                  type="Diagnosis"
                  readOnly={isTreatmentReadOnly}
                  activeTab={activeTissuetab[props.activeIndexDiagram]}
                  onEvent={props.onEvent}
                  onFocusRow={props.handleOnFocusClinialFindingsRow}
                  onOpenModalDrawing={props.handleOnOpenModalDrawing}
                  onSaveClinicalFindingById={props.handleSaveClinicalFindingById}
                  columns={columnDef}
                  // data={props.clinicalfindings}
                  data={props.clinicalfindings.filter((item: any) => props.filterClinicalFindingIds.includes(item.id))}
                  treatmentPlanList={props.treatmentPlanList}
                  filterClinicalFindingIds={props.filterClinicalFindingIds}
                  // filteredItem={props.filteredItem}
                  keyPrefix="clinicalFindingList"
                  setProp={props.setProp}
                  onFinishedEditing={props.onFinishedEditing}
                  showRowDetailById={props.showRowDetailById}
                  masterData={props.masterData}
                  showDrawingChecked={props.showDrawingChecked}
                  showDrawingCheckedAll={props.showDrawingCheckedAll}
                  // callback
                  removeRowById={(id: any) => {
                    props.setProp("openModRemoveClinicalFinding", { open: true, id: id, title: "" });
                  }}
                  // style
                  style={{ height: props.examinationTableHeight || "calc(100vh - 5rem)" }}
                  // currentencounter
                  encounterInfo={props.encounterInfo}
                />
              </div>

              <SnackMessage
                error={props.errorMessage?.[CARDNAME]}
                success={null}
                onClose={() => {
                  const errorMessage = { ...props.errorMessage };
                  delete errorMessage[CARDNAME];
                  props.setProp("errorMessage", errorMessage);
                }}
              />

              <Modal open={props.showClinicalFindingsDetail} closeIcon={true} onClose={props.onCloseClinicalFindingModal}>
                <div style={{ display: "flex", flexDirection: "column", padding: "5px" }}>
                  <ClinicalFindingsUX
                    readOnly={isTreatmentReadOnly}
                    clinicalFinding={props.clinicalFinding}
                    clinicalFindingIndex={props.clinicalFindingIndex}
                    setProp={props.setProp}
                    onEvent={props.onEvent}
                    prognosisOptions={PROGNOSIS_OPTIONS}
                  >
                    <Popup
                      trigger={
                        <Button className="circular" color="blue" style={{ width: "14px", height: "14px", padding: "0px 0px 1px 3.2px", marginLeft: "10px" }}>
                          <Icon className="small" name={"info"}></Icon>
                        </Button>
                      }
                      content="ระบุรหัสวินิจฉัยหลักที่ถูกต้องที่สุดเพียงการวินิจฉัยเดียวเท่านั้น"
                      position="top left"
                      offset={[-15, 0]}
                    />
                  </ClinicalFindingsUX>
                  <div>
                    <Button
                      circular
                      color="green"
                      style={{ margin: "10px 0" }}
                      disabled={isTreatmentReadOnly}
                      onClick={(e) => {
                        props.onEvent({ message: "AddTreatmentPlan", params: {} });
                      }}
                    >
                      <Icon name="plus" /> {intl.formatMessage({ id: "cukey447" })}
                    </Button>
                    {props.filteredTreatmentPlanList.length > 0
                      ? props.filteredTreatmentPlanList.map(
                          (item: any, index: any) =>
                            !["X"].includes(item.status) && (
                              <TreatmentItem
                                key={index}
                                item={item}
                                index={item.index}
                                setProp={props.setProp}
                                onEvent={props.onEvent}
                                statusOptions={props.statusExcludeCompleteOptions}
                                allStatusOptions={props.statusIncludeCompleteOptions}
                                urgencyOptions={props.urgencyOptions}
                                dentalTreatmentList={props.dentalTreatmentList}
                                treatmentPlanList={props.treatmentPlanList}
                                readonly={!!props.clinicalFinding?.dental_treatment_plan_have_issue || item.status === "C" || isTreatmentReadOnly}
                                errorTreatment={errorTreatment}
                                errorDivsion={errorDivsion}
                                errorDoctor={errorDoctor}
                              />
                            )
                        )
                      : ""}
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {/* <Button color="green" onClick={handleCheckTreatmentItem}>
                      {}
                    </Button> */}
                    <ButtonLoadCheck
                      disabled={isTreatmentReadOnly}
                      // function
                      setProp={props.setProp}
                      onClick={handleCheckTreatmentItem}
                      // data
                      paramKey={`${CARDNAME}_TP_SAVE`}
                      buttonLoadCheck={props.buttonLoadCheck?.[`${CARDNAME}_TP_SAVE`]}
                      // config
                      color={"green"}
                      size="medium"
                      title={intl.formatMessage({ id: "cukey187" })}
                    />
                  </div>
                </div>
                <ModConfirm
                  openModal={props.openModCancelTreatmentPlan.open}
                  titleName={"แจ้งเตือน"}
                  textContent={
                    <>
                      {"คุณต้องการลบรายการ Treatment Plan นี้หรือไม่"}
                      <br />
                      <br />
                      {props.openModCancelTreatmentPlan.title && " (" + props.openModCancelTreatmentPlan.title + ")"}
                    </>
                  }
                  content={<br />}
                  onApprove={() => {
                    props.onEvent({ message: "CancelTreatmentPlan", params: { confirm: true } });
                  }}
                  onDeny={() => props.setProp("openModCancelTreatmentPlan.open", false)}
                />
              </Modal>
              <ModConfirm
                openModal={props.openModRemoveClinicalFinding.open}
                titleName={"แจ้งเตือน"}
                textContent={"คุณต้องการลบรายการ Examination นี้ใช่หรือไม่"}
                content={<br />}
                onApprove={() => {
                  props.removeRowById(props.openModRemoveClinicalFinding.id);
                }}
                onDeny={() => props.setProp("openModRemoveClinicalFinding", { open: false, id: null, title: "" })}
              />
              <ModConfirm
                openModal={openModalError}
                titleName={"แจ้งเตือน"}
                textContent={
                  <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>{"ไม่อนุญาตให้บันทึก"}</div>
                    <div style={{ display: "flex", justifyContent: "center" }}>{"กรุณาระบุข้อมูลให้ถูกต้อง"}</div>
                  </div>
                }
                approveButtonText={null}
                denyButtonText={"ตกลง"}
                backgroundColor={"red"}
                onDeny={() => setOpenModError(false)}
              />
              <ModalSetKeyboardShortcuts
                open={props.showClinicalFindingTerms}
                keyboardShortcut={props.keyboardShortcut?.filter((item: any) => item.key_type === TEMPLATE_EXAMINATION) || []}
                onClose={() => props.setProp("showClinicalFindingTerms", false)}
                onCancel={() => props.setProp("showClinicalFindingTerms", false)}
                onDelete={(data: any) => {
                  props.onEvent({ message: "DeleteKeyboardShortcut", params: { data } });
                }}
                onSave={(data: any) => {
                  props.onEvent({ message: "SaveKeyboardShortcut", params: { data, key_type: TEMPLATE_EXAMINATION } });
                  props.setProp("showClinicalFindingTerms", false);
                }}
              />
              <ModalEditImage
                image={{ image: process.env.PUBLIC_URL + "/static/images/toothDiagram.png" }}
                openEditModal={props.openGallery.open}
                onCloseModal={() => {
                  props.onEvent({ message: "SetCloseOpenGallery", params: {} });
                }}
                cancelImage={() => {
                  props.onEvent({ message: "SetCloseOpenGallery", params: {} });
                }}
                editedImage={() => {}}
                editedImageOverlay={(data) => {
                  props.onEvent({ message: "SaveDrawingOverlay", params: { data } });
                  // props.onFinishedEditing()
                }}
                hiddenTab={false}
                activeTabs={props.openGallery.activeTabs}
                imageOverlay={props.openGallery.imageOverlayData}
                hideBabyTooth={props.openGallery.hideBabyTooth || false}
                hidePeriodontium={true}
                readOnly={isTreatmentReadOnly}
              />
            </Tab.Pane>
          ),
        },
      ]}
    />
  );
};


export const columnDef = [
  // {
  //   type: "detail",
  //   Header: "รายละเอียด",
  //   width: 5,
  // },
  {
    Header: "Location",
    accessor: "locations_name",
    width: 20,
    keySuffix: "locations_name",
    type: "input",
    masterDataSet: "organ",
    masterDataKey: "nickName",
    placeholder: "กรุณาลบแถวที่ไม่ต้องการลงบันทึก",
  },
  {
    Header: "Clinical Findings",
    accessor: "clinicaltags",
    width: 20,
    keySuffix: "clinicaltags",
    type: "input",
    masterDataSet: "clinicaltags",
    masterDataKey: "name",
  },
  {
    Header: "Other clinical findings",
    accessor: "other_clinical_finding",
    width: 20,
    type: "keyboard_shortcut",
  },
  {
    Header: "Principal Diagnosis",
    accessor: "medical_description",
    width: 20,
    keySuffix: "medical_description",
    type: "input",
    masterDataSet: "condition|academicdx",
    masterDataKey: "term",
    masterDataGroup: "icd10_label",
    selectOnFocus: true,
  },
  {
    Header: "Medical Terms / ICD10",
    accessor: "icd10_label",
    width: 30,
    keySuffix: "icd10_label",
    type: "input",
    masterDataSet: "icd10",
    masterDataKey: "icd10_label",
    selectOnFocus: true,
  },
  {
    Header: "Treatment Plan",
    accessor: "dental_treatment_plan_label",
    width: 30,
    type: "detail",
    // masterDataSet: "treatment",
    // masterDataKey: "term",
  },
  {
    Header: "",
    width: 5,
    type: "drawing",
    masterDataSet: "organ",
    accessor: "locations_name",

    // masterDataSet: "treatment",
    // masterDataKey: "term",
  },
  {
    Header: "",
    width: 5,
    type: "show_all",
  },
  {
    type: "remove",
    Header: "ลบ",
    width: 5,
  },
];

const PROGNOSIS_OPTIONS = [
  {
    key: 0,
    text: "Good",
    value: "Good",
  },
  {
    key: 1,
    text: "Fair",
    value: "Fair",
  },
  {
    key: 2,
    text: "Poor",
    value: "Poor",
  },
  {
    key: 3,
    text: "Questionable",
    value: "Questionable",
  },
  {
    key: 4,
    text: "Hopeless",
    value: "Hopeless",
  },
];

export default DiagnosisToday;
